 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import LOVE_1 from '@/components/love_1'
 import CHAP134657 from '@/components/chap134657'
 import CHAP134654 from '@/components/chap134654'
 import CHAP134653 from '@/components/chap134653'
 import CHAP134659 from '@/components/chap134659'
 import CHAP134658 from '@/components/chap134658'
 import CHAP134673 from '@/components/chap134673'
 import CHAP134674 from '@/components/chap134674'
 import CHAP134676 from '@/components/chap134676'
 import CHAP134669 from '@/components/chap134669'
 import CHAP134648 from '@/components/chap134648'
 import CHAP134670 from '@/components/chap134670'
 import CHAP134677 from '@/components/chap134677'
 import CHAP134660 from '@/components/chap134660'
 import CHAP134668 from '@/components/chap134668'
 import CHAP134656 from '@/components/chap134656'
 import CHAP134650 from '@/components/chap134650'
 import CHAP134649 from '@/components/chap134649'
 import CHAP134671 from '@/components/chap134671'
 import CHAP134651 from '@/components/chap134651'
 import CHAP134664 from '@/components/chap134664'
 import CHAP134665 from '@/components/chap134665'
 import CHAP134678 from '@/components/chap134678'
 import CHAP134662 from '@/components/chap134662'
 import CHAP134666 from '@/components/chap134666'
 import CHAP134652 from '@/components/chap134652'
 import CHAP134667 from '@/components/chap134667'
 import CHAP134655 from '@/components/chap134655'
 import CHAP134675 from '@/components/chap134675'
 import CHAP134663 from '@/components/chap134663'
 import LOVE_2 from '@/components/love_2'
 import CHAP134679 from '@/components/chap134679'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/chap134657",
 			"name" : "chap134657",
 			"component" : CHAP134657
 		},
 		{
 			"path" : "/chap134654",
 			"name" : "chap134654",
 			"component" : CHAP134654
 		},
 		{
 			"path" : "/chap134653",
 			"name" : "chap134653",
 			"component" : CHAP134653
 		},
 		{
 			"path" : "/chap134659",
 			"name" : "chap134659",
 			"component" : CHAP134659
 		},
 		{
 			"path" : "/chap134658",
 			"name" : "chap134658",
 			"component" : CHAP134658
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js